export const CAPABILITES_LIST = "CAPABILITES_LIST";
export const CAPABILITES_CREATE = "CAPABILITES_CREATE";
export const CAPABILITES_UPDATE = "CAPABILITES_UPDATE";
export const CAPABILITES_DELETE = "CAPABILITES_DELETE";
export const CAPABILITES_SHOW = "CAPABILITES_SHOW";
